import { ProductConditions } from '@ortros/stoux-lib'

export const PRODUCT_CONDITIONS_WORD = {
    [ProductConditions.NEW]: 'Neuf',
    [ProductConditions.VERY_GOOD]: 'Très bon état',
    [ProductConditions.GOOD]: 'Bon état',
    [ProductConditions.BAD]: 'État correct',
}

export const PRODUCT_CONDITIONS_COLOR = {
    [ProductConditions.NEW]: 'blue',
    [ProductConditions.VERY_GOOD]: 'green',
    [ProductConditions.GOOD]: 'yellow',
    [ProductConditions.BAD]: 'orange',
    [ProductConditions.VERY_BAD]: 'red',
}
